<template>
	<modal ref="modal" size="modal-lg">
		<template #title>{{action.toUpperCase()}} EMAIL SWIPE</template>
		<template #body>
			<div class="form-floating mb-4">
				<input v-model="form.title" type="text" id="title" name="title" class="form-control" placeholder="Title" />
				<label class="form-label" for="title">Title</label>
			</div>
			<div class="form-floating mb-4">
				<textarea v-model="form.email_format" type="text" id="email_format" name="email_format" class="form-control" placeholder="Email Format" style="height:430px;"></textarea>
				<label class="form-label" for="email_format">Email Format</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.category" type="text" id="category" name="category" class="form-control" placeholder="Category" />
				<label class="form-label" for="category">Category</label>
			</div>
			<div class="form-floating mb-4">
				<select v-model="form.status" id="status" name="status" class="form-control" placeholder="Status">
                  <option value="1">ON</option>
                  <option value="0">OFF</option>
                </select>
				<label class="form-label" for="status">Status</label>
			</div>

		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Email Swipe</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}
		
		const action = ref('add');

		const form = useForm({
			id 		: 0,
			title 			: '',
			email_format 	: '',
			category 		: '',
			status 			: 0
		})

		const actionContent = ()=>{

			if(action.value=='add')
			{
				addEmailSwipe();
			}else
			{
				updateEmailSwipe();	
			}

		}

		const addEmailSwipe = () => {
			form.post(route('admin.affiliate-program.post-email-swipe'), {
				preserveState: true,
				preserveScroll: true,
				only:['emailSwipes,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateEmailSwipe = () => {
			form.put('email-swipe/'+form.id, {
				preserveState: true,
				preserveScroll: true,
				only:['emailSwipes,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setEmailSwipeContent = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								if(_action=='update')
								{
									form.id 			= data.id;
									form.title 			= data.title;
									form.email_format 	= data.email_format;
									form.category 		= data.category;
									form.status 		= data.status;
								}
								
							}


		return {
			form,
			modal,
			toggleModal,
			action,
			setEmailSwipeContent,
			actionContent,
			addEmailSwipe,
			updateEmailSwipe,
		}
	},
}
</script>
